import { PageLoader, UIPage } from "@eventsquare/uikit";
import ProductGrid from "@components/ProductGrid/ProductGrid";
import CategoriesFilter from "@components/CategoriesFilter/CategoriesFilter";
import styles from "@styles/Store.module.scss";
import { useAppContext } from "@context/appContext";
import Cart from "@components/Cart/Cart";
import { useEffect, useState } from "react";
import CartButtons from "@components/CartButtons/Buttons";

const Dashboard = () => {
  const { products, cart } = useAppContext();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 960);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);
  const isCartEmpty = totalItems === 0;

  if (products === null) {
    return (
      <UIPage noPadding>
        <PageLoader />
      </UIPage>
    );
  }

  return (
    <UIPage noPadding>
      <div className={styles.contentWrapper}>
        <div className={styles.mainContent}>
          <div className={styles.categoryFilter}>
            <CategoriesFilter />
          </div>
          <div className={styles.productGrid}>
            <ProductGrid />
          </div>
        </div>

        {!isMobile && (
          <div className={styles.cart}>
            <div className={styles.cartInner}>
              <Cart />
              <CartButtons isCartEmpty={isCartEmpty} totalItems={totalItems} />
            </div>
          </div>
        )}

        {isMobile && (
          <CartButtons isCartEmpty={isCartEmpty} totalItems={totalItems} />
        )}
      </div>
    </UIPage>
  );
};

export default Dashboard;
